import script from "./TressImageCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TressImageCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./TressImageCarousel.vue?vue&type=style&index=0&id=202fe3b8&lang=scss"

const __exports__ = script;

export default __exports__